import * as bootstrap from 'bootstrap';
import { setupSubmitListener } from './fetch-forms';
import { initConfirmButtons } from './modal-confirm';
import { initForms } from './forms';

// Store modal instance to properly dispose it
let modalInstance: bootstrap.Modal | null = null;

function fetchModalAction(action: string, modal: HTMLElement, modalBody: HTMLElement): void {
  fetch(action)
    .then((response) => response.text())
    .then((html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const newBody = tempDiv.querySelector<HTMLElement>('.modal-body');
      if (!newBody) {
        throw new Error('Modal body not found in response.');
      }
      modalBody.innerHTML = newBody.innerHTML;

      const fetchForm = modalBody.querySelector<HTMLFormElement>('.js-fetch-form');
      if (fetchForm) {
        setupSubmitListener(fetchForm);
      }

      const confirmBtns = modalBody.querySelectorAll<HTMLElement>('.btn-confirm');
      initConfirmButtons(confirmBtns);

      initForms(modalBody);

      const options = tempDiv.querySelector<HTMLElement>('.modal-options');
      if (options) {
        const title = options.getAttribute('data-biz-title');
        if (title) {
          const modalTitle = modal.querySelector<HTMLElement>('.modal-title');
          if (modalTitle) {
            modalTitle.innerText = title;
          }
          const oldTitle = document.title;
          document.title = title;

          const titleResetHandler = () => {
            document.title = oldTitle;
            modal.removeEventListener('hidden.bs.modal', titleResetHandler);
          };
          modal.addEventListener('hidden.bs.modal', titleResetHandler);
        }

        const size = options.getAttribute('data-biz-modal-size');
        if (size) {
          const modalDialog = modal.querySelector<HTMLElement>('.modal-dialog');
          if (modalDialog) {
            modalDialog.className = 'modal-dialog ' + size;
          }
        }

        const modalUrl = options.getAttribute('data-biz-url-params');
        if (modalUrl) {
          const oldParams = new URLSearchParams(window.location.search);
          const urlParams = new URLSearchParams(JSON.parse(modalUrl));

          for (const [key, value] of urlParams.entries()) {
            oldParams.set(key, value);
          }

          const newUrl = window.location.pathname + '?' + oldParams.toString();
          history.replaceState(null, '', newUrl);

          const urlResetHandler = () => {
            for (const [key] of urlParams.entries()) {
              oldParams.delete(key);
            }

            const updatedUrl = window.location.pathname + '?' + oldParams.toString();
            history.replaceState(null, '', updatedUrl);
            modal.removeEventListener('hidden.bs.modal', urlResetHandler);
          };
          modal.addEventListener('hidden.bs.modal', urlResetHandler);
        }
      }

      // Dispose existing instance if any
      if (modalInstance) {
        modalInstance.dispose();
        modalInstance = null;
      }

      // Create new instance and store it
      modalInstance = new bootstrap.Modal(modal);

      // Clean up instance when modal is hidden
      const cleanupHandler = () => {
        if (modalInstance) {
          modalInstance.dispose();
          modalInstance = null;
        }
        modal.removeEventListener('hidden.bs.modal', cleanupHandler);
      };
      modal.addEventListener('hidden.bs.modal', cleanupHandler);

      modalInstance.show();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching modal:', error);
    });
}

export async function initFetchModal(parent: HTMLElement | Document): Promise<void> {
  const modal = document.querySelector<HTMLElement>('#fetchModal');
  if (!modal) return;

  const modalBody = modal.querySelector<HTMLElement>('.modal-body');
  if (!modalBody) {
    // eslint-disable-next-line no-console
    console.warn('Modal body not found in modal.');
    return;
  }

  const btns = parent.querySelectorAll<HTMLElement>('.btn-modal');
  for (const btn of btns) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const action = btn.getAttribute('data-biz-action');
      if (action) {
        fetchModalAction(action, modal, modalBody);
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const action = (window as any).modalAction;
  if (action) {
    fetchModalAction(action, modal, modalBody);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).modalAction = undefined;
  }
}
